import React from 'react';
import Layout from '../../components/Layout';

const TermsOfUse = () => {
  return (
    <Layout>
      <div className="py-12 max-w-4xl mx-auto">
        <h2 className="text-4xl font-extrabold text-indigo-400 mb-6 border-b-2 border-teal-500 pb-2">
          Terms of Use & Disclaimers
        </h2>
        
        <h3 className="text-2xl font-semibold text-white mt-8 mb-4">1. Non-Financial Advice</h3>
        <p className="text-gray-300 mb-6">
          The information provided by this application is for informational and demonstration purposes only. 
          It should not be construed as financial, investment, or legal advice. 
          Always conduct your own research (DYOR) before making any investment decisions.
        </p>
        
        <h3 className="text-2xl font-semibold text-white mt-8 mb-4">2. Beta Software</h3>
        <p className="text-gray-300">
          This is an MVP (Minimum Viable Product) and should be considered beta software. 
          The developers make no guarantees regarding uptime, accuracy, or security. Use at your own risk.
        </p>
      </div>
    </Layout>
  );
};

export default TermsOfUse;
